import { render, staticRenderFns } from "./UserProfileAddress.vue?vue&type=template&id=cd8653e2"
import script from "./UserProfileAddress.vue?vue&type=script&lang=js"
export * from "./UserProfileAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports